export const AppConstants = {
  STORAGE_KEYS: {
    Plans: 'Plans',
    SelectedPlan: 'SelectedPlan',
    SelectedPlanNumber: 'SelectedPlanNumber',
    PlansCount: 'PlansCount',
    UserPortalAccount: 'UserPortalAccount',
    IsCoverageSectionAvailable: 'IsCoverageSectionAvailable',
    PlanDetail: 'PlanDetail',
    PurchasedAddons: 'PurchasedAddons',
    PurchasedAlertDisplayed: 'PurchasedAlertDisplayed',
    UserProfile: 'user-profile',
    IdentityToken: 'identity-token',
    IdentityTokenStorage: 'identity-token-storage',
    IdentityUser: 'identity-user',
    ElitaEnvironment: 'elita-environment',
    ElitaEnvironmentDefault: 'elita-environment-default',
    UserSessionId: 'UserSessionId',
    CustomerInfo: 'customer-info',
    AfxAddons: 'AfxAddons',
    AfxRenewal: 'AfxRenewal',
    PaymentCardNoticeDismissed: 'PaymentCardNoticeDismissed',
    AutoRenewOffNoticeDismissed: 'AutoRenewOffNoticeDismissed',
    ContentEditorId: 'content-editor-id',
    ContentEditorEmail: 'content-editor-email',
    PlanDetailsTotalCount: 'PlanDetailsTotalCount',
    CancelPlanState: 'CancelPlanState',
  },
  HEADERS: {
    IdentityToken: 'IdentityToken',
    UserSessionId: 'X-User-Session-Id',
  },
  // Router.navigate({ state }) flags — in-memory only (do NOT survive a hard refresh or direct
  // URL entry), used to prove a route was reached via an expected in-app action rather than
  // deep-linking. Read via `router.getCurrentNavigation()?.extras?.state?.[key]`.
  ROUTE_NAV_STATE: {
    PlanRenewalFromRenewClick: 'fromRenewClick',
  },
  API_ENDPOINTS: {
    PortalProfile: 'portalprofile',
    PlanDetails: 'plandetails',
    BulkPlanDetails: 'bulkplandetails',
    PolicyDocument: 'policydocument',
    RenewIdentityToken: 'renew-identity-token',
    // Live policy-cancellation middleware (Elita-backed) — see cancellation.service.ts CancelPlan_UseMock gate
    CancelPlanEligibility: 'policy-cancellation/can-cancel',
    CancelPlan: 'policy-cancellation/cancel',
    ConfirmContactInfo: 'policy-cancellation/confirm-contact-info',
    VerifySessionToken: 'sso/token/verify',
    EndorseCertificateItem: 'endorse-certificate-item',
  },
  GSSP_REDIRECT_URL: {
    FileClaim: 'file-claim',
    TrackClaim: 'track-claim',
    Dashboard: 'dashboard',
  },
  PLAN_STATUS: {
    Active: 'Active',
    Expired: 'Expired',
    Cancelled: 'Cancelled',
    Suspended: 'Suspended',
  },
  PLAN_CUSTOMER_TYPE: {
    Primary: 'Primary',
  },
  PLAN_ADDRESS_TYPE: {
    Primary: 'Primary',
  },
  PLAN: {
    PlanTier: {
      Good: 'Good',
      Better: 'Better',
      Best: 'Best',
      Listing: 'Listing',
    },
    Deductible: {
      Fixed: 'FIXED',
      MethodOfRepairCodeH: 'H',
      Source: 'CVG_DED|CVG',
    },
  },
  CLAIM: {
    Status: {
      Incomplete: 'Incomplete',
      Pending: 'Pending',
      Approved: 'Approved',
      Denied: 'Denied',
      Closed: 'Closed',
      Cancelled: 'Cancelled',
    }
  },
  CHAT: {
    MIAW: {
      BadgeId: 'miaw-chat-messaging',
      HiddenClass: 'miawChatBadge_hidden',
      ClosedClass: 'embeddedservice_chat_minimized',
    },
    ASAPP: {
      BadgeId: 'asapp-chat-sdk-badge',
      HiddenClass: 'asappChatSDKBadge_hidden',
      ClosedClass: 'asappChatSDKBadge_closed',
    }
  },
  DOCUMENT_TYPES: {
    TERMS_AND_CONDITIONS: 'T_AND_C',
  },
  AFX_RESPONSE_CODE: {
    // As per current implementation in backend, AFX response code for successful transaction is 200. This can be enhanced in future to include other success codes if needed.
    Success: 200,
  },
  IDENTITY_TOKEN: {
    Subject: 'Home Warranty',
    Issuer: 'assurant',
  },
  RENEWAL_STATUS: {
    Completed: 'completed',
    Abandoned: 'abandoned',
    Cancelled: 'cancelled',
  },
};
